module.exports = __webpack_public_path__ + "media/img/event/vsf-sponsor-4f923a2a02606386be31ece73431c296.jpg";